<template>
  <div class="upload-file">
    <b-modal
      id="repApproveModal"
      centered
      size="md"
      no-close-on-backdrop
      hide-footer
      v-if="row"
    >
      <template #modal-header>
        <div class="pb-1 repApproveModal-header text-center">
          <h4>Approval Request</h4>
          <b-button
            variant="close-btn"
            class="btn-container"
            @click="closeModal"
          >
            <i class="fas fa-times"></i>
          </b-button>
        </div>
      </template>
      <b-container fluid>
        <div class="d-flex repApproveModal-form">
          <div class="exclaim-bg">
            <img src="../../../assets/images/exclaim.svg" />
          </div>
          <div class="">
            <div class="note-txt">
              Do you want to proceed and approve this card request?
            </div>
            <div class="d-flex align-items-center gap-2 mt-4">
              <label for="cards_request"> A<b> $5.00 fee will be charged  </b>to this member if the requested is approved.
              </label>
            </div>
            <div class="note-txt">
              Would you like to charge the $5.00 fee?
            </div>
            <div class="d-flex align-items-center gap-2 mt-4 justify-content-center">
              <b-form-checkbox v-model="cards_request" value="1" class="checkbox-default" unchecked-value="0">
              </b-form-checkbox>
              <label for="cards_request">Yes, charge the member</label>

              <b-form-checkbox v-model="cards_request" value="0" class="checkbox-default" unchecked-value="0">
              </b-form-checkbox>
              <label for="cards_request">No, do not charge</label>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-end gap-2 mt-4">
          <button class="cancel-btn request-cancel m-0" @click="closeModal">Cancel</button>
          <button class="approve-btn univ-btn m-0" @click="acceptRequest">Yes Approve</button>
        </div>
      </b-container>
    </b-modal>
  </div>
</template>
<script>
import AdminApi from '@/resource/AdminApi'

export default {
  name: "RepApproveModal",
  props: {
    row: {
      required: true,
    },
  },
  data() {
    return {
      cards_request: "0"
    };
  },
  methods: {
    reset() {
      this.$emit("update:row", null);
    },
    closeModal() {
      this.$bvModal.hide("repApproveModal");
      this.reset();
    },
    acceptRequest() {
      let url = '/api/v2/rep-info-request/approve-request';
      let loader = this.$loading.show();
      let data = {
        id: this.row.id,
        cards_request: (this.cards_request === "1") ? true : false
      }
      AdminApi.put(url, data)
        .then((res) => {
           this.$notify(res.data.message)
           this.$emit("onSuccess")
           this.closeModal()
        })
        .catch((err) => {
          console.log(err)
          this.$notify("Something went wrong. Please try again.", "error");
        }).finally(() => {
        loader.hide()
      })
      
    },
  },
};
</script>
  
  <style>
    .note-txt{
    font-size: 16px;
  }
  .request-cancel{
    background: #6C757D;
    color: #fff;
    border-radius: 4px;
    padding: 0.6rem 3rem;
    margin: 0;
    border: none;
  }
.repApproveModal-header h4 {
  font-size: 20px;
  color: #2c3f58;
  font-weight: 600;
  margin-bottom: 0;
}
.repApproveModal-header p {
  font-size: 14px;
  color: #2c3f58;
}
.repApproveModal-header button {
  position: absolute;
  top: -15px;
  right: -15px;
  background: #fff;
  color: #000;
  border: 0;
  box-shadow: -2px 2px 13px -4px rgb(0 0 0 / 46%);
  border-radius: 60px;
  font-size: 18px;
  width: 45px;
  height: 45px;
  align-items: center;
  justify-content: center;
  display: flex;
}
.repApproveModal-form label {
  display: block;
  color: #5e5e5e;
  font-size: 14px;
  margin-bottom: 8px;
  font-weight: 500;
}
.repApproveModal-form .custom-field {
  width: 100%;
  border: 1px solid #dce1e7;
  outline: none;
  border-radius: 6px;
  padding: 9px 15px;
  font-size: 14px;
  transition: all ease 0.6s;
}
.univ-btnEdit,
.univ-btnEdit:focus {
  background: linear-gradient(#0cf, #1597b8 49%, #0567bc);
  border-radius: 6px;
  color: #fff;
  outline: none;
  border: 0;
  width: 100%;
  text-align: center;
  padding: 10px 0;
  margin-top: 10px;
  transition: all ease 0.6s;
  box-shadow: inherit;
}
.modal-content {
  border: 0;
  border-radius: 15px;
}
.modal-header {
  justify-content: center;
  border: 0;
  padding: 25px 0 ;
  position: relative;
}
.repApproveModal-header .btn-container {
  position: absolute;
  top: -14px !important;
  right: -15px;
  background: #fff;
  color: #000;
  border: 0;
  box-shadow: -2px 2px 13px -4px rgb(0 0 0 / 46%);
  border-radius: 60px;
  font-size: 18px;
  width: 45px;
  height: 45px;
  align-items: center;
  justify-content: center;
  display: flex;
}
.exclaim-bg {
  background: #f9f5f2;
  border-radius: 50px;
  height: fit-content;
  padding: 1rem;
  position: relative;
  margin-right: 0.8rem;
}
.exclaim-bg img {
  position: absolute;
  right: 3px;
  top: 3px;
}

.modal-header {
  padding-bottom: 0 !important;
}
.approve-btn{
  padding: 0.65rem 3rem;
  max-width: fit-content !important;
}
</style>